import React, { useState } from "react";
import alyseiIcon from "../../../assets/landing-page/alysei-icon-only.png";

const BROWSE_ALL_VALUE = "__browse_all_categories__";

const formatTime = (timestamp) => {
  const d = new Date(timestamp);
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
};

const UserBubble = ({ message }) => {
  return (
    <div className="flex items-center gap-2 justify-end animate-fadeIn">
      <div className="flex flex-col items-end gap-1" style={{ maxWidth: "75%" }}>
        <div className="text-white px-3 py-2 rounded-xl rounded-br-sm shadow-sm text-sm leading-relaxed" style={{ backgroundColor: "#0d9488" }}>
          {message.text}
        </div>
        <span className="text-gray-400 px-1  text-left" style={{ fontSize: "10px" }}>{formatTime(message.timestamp)}</span>
      </div>

      <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0 shadow text-gray-500">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/>
        </svg>
      </div>
    </div>
  );
};

const CategoryButton = ({ label, onClick, disabled }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className="text-left text-sm px-4 py-3 rounded-lg bg-white border disabled:opacity-50 transition-colors"
    style={{
      borderColor: "#d1d5db",
      color: "#004577",
      fontWeight: 600,
      fontSize: "13px",
      boxShadow: "none",
    }}
    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#f0f6ff"; }}
    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#fff"; }}
  >
    {label}
  </button>
);

const QuickRepliesGrid = ({ quickReplies, categoriesGrouped, onQuickReply, isLoading }) => {
  const [showAll, setShowAll] = useState(false);

  const browseAllItem = quickReplies.find((r) => r.value === BROWSE_ALL_VALUE);
  const regularReplies = quickReplies.filter((r) => r.value !== BROWSE_ALL_VALUE);

  if (showAll && categoriesGrouped) {
    return (
      <div className="mt-3 flex flex-col gap-5">
        {Object.entries(categoriesGrouped).map(([group, items]) => (
          <div key={group}>
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2 px-1">{group}</p>
            <div className="grid grid-cols-2 gap-2">
              {items.map((item) => (
                <CategoryButton
                  key={item.value}
                  label={item.label}
                  onClick={() => onQuickReply(item.value)}
                  disabled={isLoading}
                />
              ))}
            </div>
          </div>
        ))}
        <button
          onClick={() => setShowAll(false)}
          className="text-xs text-gray-400 hover:text-gray-600 self-start px-1"
        >
          ← Show fewer
        </button>
      </div>
    );
  }

  return (
    <div className="mt-3">
      <div className="grid grid-cols-2 gap-1.5">
        {regularReplies.map((reply) => (
          <CategoryButton
            key={reply.value}
            label={reply.label}
            onClick={() => onQuickReply(reply.value)}
            disabled={isLoading}
          />
        ))}
        {browseAllItem && (
          <CategoryButton
            key={browseAllItem.value}
            label={browseAllItem.label}
            onClick={() => setShowAll(true)}
            disabled={isLoading}
          />
        )}
      </div>
    </div>
  );
};

const AssistantBubble = ({ message, onQuickReply, isLoading }) => (
  <div className="flex items-start gap-3 justify-start animate-fadeIn">
    <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center flex-shrink-0 overflow-hidden shadow mt-0.5">
      <img src={alyseiIcon} alt="Alysei AI" className="w-5 h-5 object-contain" />
    </div>

    <div className="flex flex-col gap-1" style={{ maxWidth: "88%" }}>
      {message.text ? (
        <div className="bg-white border border-gray-100 shadow-sm px-3 py-2 rounded-xl rounded-bl-sm text-sm text-gray-800 leading-relaxed whitespace-pre-wrap">
          {message.text}
        </div>
      ) : null}

      {message.quickReplies?.length > 0 && (
        <QuickRepliesGrid
          quickReplies={message.quickReplies}
          categoriesGrouped={message.categoriesGrouped}
          onQuickReply={onQuickReply}
          isLoading={isLoading}
        />
      )}

      <span className="text-gray-400 px-1  text-left" style={{ fontSize: "10px" }}>{formatTime(message.timestamp)}</span>
    </div>
  </div>
);

const MessageBubble = ({ message, onQuickReply, isLoading }) => {
  if (message.role === "user") {
    return <UserBubble message={message} />;
  }
  return <AssistantBubble message={message} onQuickReply={onQuickReply} isLoading={isLoading} />;
};

export default MessageBubble;
